// src/pages/AgentSignup.jsx
// Route: <Route exact path='/AgentSignup' component={AgentSignup} />
// Used when the Telegram agent sends a new user to create a ThinkLead account.
// Opens directly in signup mode — no toggle needed.

import React from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { signInWithGoogle, signUpNewUsers } from '../store/actions/authActions';
import { getAllCompanySettings, getAllGeneralSettings } from '../store/actions/companyAdminActions';
import { showToast } from '../store/actions/toastAction';
import { SHOW_TOAST, FB_URL } from '../store/actions/types';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
//import { FormControl, MenuItem, InputLabel, FormControlLabel } from '@material-ui/core';
//import { FormControl, MenuItem, InputLabel, FormControlLabel } from '@material-ui/core';
import { FormControlLabel } from '@material-ui/core';
//import Select from '@mui/material/Select';
import Select from '@material-ui/core/Select';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import ThinkLeadLogo from './../components/LandingPage/img/mevLand.jpg'
import mevImage from './../components/LandingPage/img/mevLand.jpg'

import axios from 'axios';
import firebaseCompat from '../utils/firebaseCompat';
//import { PHOTO_PROFILE } from '../utils/photo_utils'
import firebase from '../store/firebase'
import SvgIcon from '@material-ui/core/SvgIcon';
import Hidden from '@material-ui/core/Hidden';
import Media from 'react-media';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  disableScrollLock: true,
};

function GoogleIcon(props) {
  return (
    <SvgIcon {...props} fill='#000000' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='64px' height='64px'>
      <path d='M 16.003906 14.0625 L 16.003906 18.265625 L 21.992188 18.265625 C 21.210938 20.8125 19.082031 22.636719 16.003906 22.636719 C 12.339844 22.636719 9.367188 19.664063 9.367188 16 C 9.367188 12.335938 12.335938 9.363281 16.003906 9.363281 C 17.652344 9.363281 19.15625 9.96875 20.316406 10.964844 L 23.410156 7.867188 C 21.457031 6.085938 18.855469 5 16.003906 5 C 9.925781 5 5 9.925781 5 16 C 5 22.074219 9.925781 27 16.003906 27 C 25.238281 27 27.277344 18.363281 26.371094 14.078125 Z'/>
    </SvgIcon>
  );
}

const styles = {
  button: {
    marginTop: 20,
    backgroundColor: '#ffde59',
    borderRadius: 3,
    border: 0,
    color: '#000',
    height: 48,
    padding: '0 20px',
    textTransform: 'none',
  },
  main: {
    marginTop: '20vh',
  },
  createAccount: {
    marginRight: 0,
    backgroundColor: '#ffde59',
    borderRadius: 3,
    border: 0,
    color: '#000',
    height: 48,
    padding: '0 15px',
    textDecoration: 'none',
    display: 'inline-block',
    textAlign: 'center',
    lineHeight: '48px',
    fontWeight: 'normal',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    minWidth: '120px',
    fontSize: '13px',
    cursor: 'pointer',
  },
};

class AgentSignup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Email confirmation step
      phase: 'email',          // 'email' | 'signup' | 'done'
      emailInput: '',
      confirmEmailLoading: false,
      confirmEmailMessage: '',
      confirmEmailError: '',

      // Signup form
      firstName: '',
      lastName: '',
      username: '',            // confirmed email, pre-filled after confirmation
      password: '',
      showPassword: false,
      position: '',
      department: '',
      nationality: '',
      agreeTCs: false,
      selectClub: '-NRbTwxbqFLepk62Eq6M',
      clubName: 'Me-Vision Academy',

      // Token
      pendingLinkToken: '',

      isSubmitting: false,
    };
  }

  componentDidMount() {
    // Read linkToken from URL
    const linkToken = new URLSearchParams(window.location.search).get('linkToken');
    if (linkToken) {
      this.setState({ pendingLinkToken: linkToken });
      localStorage.setItem('pendingLinkToken', linkToken);
    }

    // If returning from email confirmation link
    if (firebaseCompat.auth().isSignInWithEmailLink(window.location.href)) {
      let email = localStorage.getItem('emailForSignIn');
      if (!email) {
        email = window.prompt('Please re-enter your email to confirm:');
      }
      if (!email || !email.trim()) {
        this.setState({ confirmEmailError: 'Confirmation cancelled.' });
        window.history.replaceState({}, document.title, window.location.pathname);
        return;
      }
      email = email.trim();
      this.setState({ confirmEmailMessage: 'Confirming your email...' });

      firebaseCompat.auth()
        .signInWithEmailLink(email, window.location.href)
        .then(() => {
          localStorage.removeItem('emailForSignIn');

          // Save confirmation to backend
          const safeEmail = email.replace(/\./g, '_');
          const updates = {};
          updates[`/emailconfirmations/${safeEmail}`] = {
            timestamp: Date.now(),
            email: email,
            status: true,
          };
          axios.post(`${FB_URL}/m115-freshcard`, { updates }).catch(() => {});

          return firebaseCompat.auth().signOut();
        })
        .then(() => {
          // Stay on this page in signup phase — clean the URL
          const pendingToken = localStorage.getItem('pendingLinkToken');
          window.history.replaceState({}, document.title, window.location.pathname);
          // Move to signup phase with email pre-filled
          this.setState({
            phase: 'signup',
            username: email,
            pendingLinkToken: pendingToken || this.state.pendingLinkToken,
            confirmEmailMessage: '',
          });
        })
        .catch(() => {
          this.setState({ confirmEmailError: 'Invalid or expired confirmation link. Please try again.' });
          window.history.replaceState({}, document.title, window.location.pathname);
        });

      return;
    }

    // Check if email was already confirmed this session
const isConfirmed = sessionStorage.getItem('agentEmailConfirmed') === 'true';
const confirmedEmail = sessionStorage.getItem('agentConfirmedEmail') || '';
if (isConfirmed && confirmedEmail) {
  sessionStorage.removeItem('agentEmailConfirmed');
  sessionStorage.removeItem('agentConfirmedEmail');
  this.setState({
    phase: 'signup',
    username: confirmedEmail,
  });
}

    this.props.getAllGeneralSettings({});
    this.props.getAllCompanySettings({});
  }

componentDidUpdate(prevProps) {
  // If user just became logged in, redirect to main app
  if (this.props.auth && this.props.auth.uid && !prevProps.auth?.uid) {
    window.location.href = '/';
  }
}

mapStateToProps = (state) => ({
  auth: state.firebase?.auth || state.auth,
  company_settings: state.users.company_settings,
  general_settings: state.users.general_settings,
});

  handleSendConfirmation = () => {
    const email = this.state.emailInput.trim();
    if (!email || !email.includes('@')) {
      this.setState({ confirmEmailError: 'Please enter a valid email address.' });
      return;
    }

    this.setState({ confirmEmailLoading: true, confirmEmailError: '', confirmEmailMessage: '' });

    // Build continueUrl pointing back to this page with the linkToken
    const linkToken = this.state.pendingLinkToken || localStorage.getItem('pendingLinkToken') || '';
    const continueUrl = linkToken
      ? `${window.location.origin}/AgentSignup?linkToken=${linkToken}`
      : `${window.location.origin}/AgentSignup`;

    const actionCodeSettings = {
      url: continueUrl,
      handleCodeInApp: true,
    };

    firebaseCompat.auth()
      .sendSignInLinkToEmail(email, actionCodeSettings)
      .then(() => {
        localStorage.setItem('emailForSignIn', email);
        sessionStorage.setItem('agentEmailConfirmed', 'false');
        sessionStorage.setItem('agentConfirmedEmail', email);
        this.setState({
          confirmEmailLoading: false,
          confirmEmailMessage: 'Confirmation link sent! Check your email including spam folder.',
        });
      })
      .catch((err) => {
        this.setState({
          confirmEmailLoading: false,
          confirmEmailError: err.message || 'Failed to send confirmation link. Please try again.',
        });
      });
  };

  handleSignUp = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;

    if (!this.state.agreeTCs) {
      this.props.showToast({
        type: SHOW_TOAST,
        open: true,
        variant: 'warning',
        message: 'Please agree to the ThinkLead Terms and Conditions.',
        pos: 'top',
      });
      return;
    }

    const email = (this.state.username || '').trim();
    const password = (this.state.password || '').trim();

    if (!email || !password) {
      this.props.showToast({
        type: SHOW_TOAST,
        open: true,
        variant: 'error',
        message: 'Email and password are required.',
        pos: 'top',
      });
      return;
    }

    this.setState({ isSubmitting: true });

    const payload = {
      params: {
        email,
        password,
        firstName: (this.state.firstName || '').trim(),
        lastName: (this.state.lastName || '').trim(),
        selectClub: this.state.selectClub || '-NRbTwxbqFLepk62Eq6M',
        clubName: this.state.clubName || 'Me-Vision Academy',
        department: (this.state.department || '').trim(),
        position: (this.state.position || '').trim(),
        nationality: (this.state.nationality || '').trim(),
        agreeTCs: true,
        pendingLinkToken: this.state.pendingLinkToken || localStorage.getItem('pendingLinkToken') || '',
      },
    };

    this.props.SignUpWithEmail(payload);
      // Redirect to home after a short delay to allow signup to complete
      setTimeout(() => {
        window.location.href = '/';
      }, 3000);
  };

  handleChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  handleChecked = (prop) => (event) => {
    this.setState({ [prop]: event.target.checked });
  };

  renderGeneralSettings = (type) => {
    const itemdata = this.props.general_settings && this.props.general_settings[type]
      ? this.props.general_settings[type]
      : [];
    if (itemdata.length > 0) {
      return itemdata.map((v, i) => <MenuItem key={i} value={v}>{v}</MenuItem>);
    }
    return [<MenuItem key="no-data" value="" disabled>No {type} options available</MenuItem>];
  };

  renderCompanySettings = (type) => {
    if (this.props.company_settings && this.props.company_settings[type]) {
      const itemdata = [...this.props.company_settings[type]].sort();
      return itemdata.map((v, i) => <MenuItem key={i} value={v}>{v}</MenuItem>);
    }
    return null;
  };

  render() {
    const { classes } = this.props;
    const {
      phase,
      emailInput,
      confirmEmailLoading,
      confirmEmailMessage,
      confirmEmailError,
      firstName,
      lastName,
      username,
      password,
      showPassword,
      position,
      department,
      nationality,
      agreeTCs,
    } = this.state;

    const isSignupInvalid =
      password.trim().length < 6 ||
      (username || '').trim() === '' ||
      firstName.trim() === '' ||
      lastName.trim() === '' ||
      !agreeTCs;

    return (
      <React.Fragment>
        <CssBaseline />
        <Container maxWidth='md'>
          <Grid container style={{ backgroundColor: '#1025a2' }}>

            <Grid item xs={12} sm={5} md={5} className={classes.main}>
              <Hidden smDown>
                <img src={mevImage} style={{ width: '100%', height: 'auto', marginTop: '-10px' }} alt="ThinkLead" />
              </Hidden>
            </Grid>

            <Grid item xs={12} sm={5} md={5} className={classes.main}>
              <Media queries={{ small: '(max-width: 599px)' }}>
                {matches => matches.small
                  ? <img src={ThinkLeadLogo} style={{ width: '100%', height: 'auto' }} alt="ThinkLead" />
                  : null}
              </Media>

              {/* ===== PHASE 1: EMAIL CONFIRMATION ===== */}
              {phase === 'email' && (
                <div>
                  <Typography variant="h6" style={{ color: '#fff', marginBottom: 16, textAlign: 'center' }}>
                    Create your ThinkLead account
                  </Typography>
                  <Typography variant="body2" style={{ color: '#ccc', marginBottom: 16, textAlign: 'center' }}>
                    First, confirm your email address.
                  </Typography>

                  <TextField
                    variant='outlined'
                    margin='dense'
                    value={emailInput}
                    placeholder='Your email address'
                    type='email'
                    fullWidth
                    onChange={(e) => this.setState({ emailInput: e.target.value, confirmEmailError: '' })}
                    style={{ backgroundColor: '#ffffff', borderRadius: 5 }}
                  />

                  {confirmEmailError && (
                    <Typography style={{ color: '#ff6b6b', fontSize: 13, marginTop: 8 }}>
                      {confirmEmailError}
                    </Typography>
                  )}

                  {confirmEmailMessage && (
                    <Typography style={{ color: '#90ee90', fontSize: 13, marginTop: 8 }}>
                      {confirmEmailMessage}
                    </Typography>
                  )}

                  <Button
                    variant='contained'
                    onClick={this.handleSendConfirmation}
                    disabled={confirmEmailLoading}
                    fullWidth
                    style={{
                      marginTop: 16,
                      backgroundColor: '#ffde59',
                      color: '#000',
                      height: 48,
                      textTransform: 'none',
                      fontWeight: 'bold',
                    }}
                  >
                    {confirmEmailLoading ? 'Sending...' : 'Send Confirmation Email'}
                  </Button>
                </div>
              )}

              {/* ===== PHASE 2: SIGNUP FORM ===== */}
              {phase === 'signup' && (
                <div>
                  <Typography variant="h6" style={{ color: '#fff', marginBottom: 16, textAlign: 'center' }}>
                    Complete your registration
                  </Typography>

                  <TextField
                    variant='outlined'
                    margin='dense'
                    value={firstName}
                    placeholder='First Name'
                    fullWidth
                    onChange={this.handleChange('firstName')}
                    style={{ backgroundColor: '#ffffff', borderRadius: 5 }}
                  />

                  <TextField
                    variant='outlined'
                    margin='dense'
                    value={lastName}
                    placeholder='Last Name'
                    fullWidth
                    onChange={this.handleChange('lastName')}
                    style={{ backgroundColor: '#ffffff', borderRadius: 5 }}
                  />

                  <TextField
                    variant='outlined'
                    margin='dense'
                    value={username}
                    placeholder='Email'
                    type='email'
                    fullWidth
                    disabled={true}
                    style={{ backgroundColor: '#e8e8e8', borderRadius: 5 }}
                  />

                  <TextField
                    variant='outlined'
                    margin='dense'
                    placeholder='Password (min 6 characters)'
                    value={password}
                    type={showPassword ? 'text' : 'password'}
                    autoComplete='new-password'
                    fullWidth
                    onChange={this.handleChange('password')}
                    style={{ backgroundColor: '#fff', borderRadius: 5 }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton onClick={() => this.setState({ showPassword: !showPassword })}>
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
{/* 
            <FormControl fullWidth style={{ marginTop: 10, marginBottom: 5 }}>
              <InputLabel id='position-label'>Select Position/Title</InputLabel> */}
            <select
              value={position}
              onChange={this.handleChange('position')}
              style={{
                width: '100%', padding: '14px 12px', marginTop: 10, marginBottom: 5,
                backgroundColor: '#ffffff', borderRadius: 5, border: '1px solid #ccc',
                fontSize: 16, color: position ? '#000' : '#757575',
              }}
            >
              <option value="" disabled>Select Position/Title</option>
              {this.props.general_settings?.position?.map((v, i) => (
                <option key={i} value={v}>{v}</option>
              ))}
            </select>
           {/*  </FormControl> */}

                  {/* <FormControl fullWidth style={{ marginTop: 5, marginBottom: 5 }}>
                    <InputLabel id='department-label'>Select Sector/Industry</InputLabel> */}
                  <select
                    value={department}
                    onChange={this.handleChange('department')}
                    style={{
                      width: '100%', padding: '14px 12px', marginTop: 5, marginBottom: 5,
                      backgroundColor: '#ffffff', borderRadius: 5, border: '1px solid #ccc',
                      fontSize: 16, color: department ? '#000' : '#757575',
                    }}
                  >
                    <option value="" disabled>Select Sector/Industry</option>
                    {this.props.company_settings?.departments?.map((v, i) => (
                      <option key={i} value={v}>{v}</option>
                    ))}
                  </select>
                  {/* </FormControl> */}

                  {/* <FormControl fullWidth style={{ marginTop: 5, marginBottom: 10 }}>
                    <InputLabel id='nationality-label'>Select Country</InputLabel> */}
                  <select
                    value={nationality}
                    onChange={this.handleChange('nationality')}
                    style={{
                      width: '100%', padding: '14px 12px', marginTop: 5, marginBottom: 10,
                      backgroundColor: '#ffffff', borderRadius: 5, border: '1px solid #ccc',
                      fontSize: 16, color: nationality ? '#000' : '#757575',
                    }}
                  >
                    <option value="" disabled>Select Country</option>
                    {this.props.general_settings?.nationality?.map((v, i) => (
                      <option key={i} value={v}>{v}</option>
                    ))}
                  </select>
                  {/* </FormControl> */}

                  <div style={{
                    marginTop: 20,
                    marginBottom: 15,
                    backgroundColor: '#ffffff',
                    borderRadius: 5,
                    padding: '10px 15px',
                    border: '1px solid #e0e0e0',
                  }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={agreeTCs}
                          onChange={this.handleChecked('agreeTCs')}
                          color='primary'
                        />
                      }
                      label={
                        <span style={{ fontSize: '14px', color: '#333' }}>
                          I agree to the ThinkLead Terms and Conditions
                        </span>
                      }
                      style={{ margin: 0 }}
                    />
                  </div>

                  <Button
                    variant='contained'
                    onClick={this.handleSignUp}
                    disabled={isSignupInvalid || this.state.isSubmitting}
                    fullWidth
                    style={{
                      marginTop: 0,
                      backgroundColor: '#ffde59',
                      borderRadius: 3,
                      color: '#000',
                      height: 48,
                      textTransform: 'none',
                      fontWeight: 'bold',
                    }}
                  >
                    SIGN UP
                  </Button>

                  {isSignupInvalid && (
                    <div style={{
                      marginTop: 10,
                      padding: '10px',
                      backgroundColor: '#fff3cd',
                      border: '1px solid #ffc107',
                      borderRadius: '5px',
                      fontSize: '14px',
                      color: '#856404',
                      textAlign: 'center',
                    }}>
                      {password.trim().length < 6 && <div>• Password must be at least 6 characters</div>}
                      {!firstName.trim() && <div>• First name is required</div>}
                      {!lastName.trim() && <div>• Last name is required</div>}
                      {!agreeTCs && <div>• You must agree to Terms and Conditions</div>}
                    </div>
                  )}

                  <Grid container direction='row' justify='center' style={{ marginTop: 25, marginBottom: 15 }}>
                    <span
                      className={classes.createAccount}
                      onClick={() => window.location.href = '/'}
                    >
                      Already have an account? Sign In
                    </span>
                  </Grid>
                </div>
              )}

            </Grid>
          </Grid>
        </Container>
      </React.Fragment>
    );
  }
}

const AgentSignupStyled = withStyles(styles)(AgentSignup);

const mapStateToProps = (state) => ({
  company_settings: state.users.company_settings,
  general_settings: state.users.general_settings,
});

const mapDispatchToProps = (dispatch) => ({
  SignUpWithEmail: (params) => dispatch(signUpNewUsers(params)),
  signGoogle: (params) => dispatch(signInWithGoogle(params)),
  getAllCompanySettings: (params) => dispatch(getAllCompanySettings(params)),
  getAllGeneralSettings: (params) => dispatch(getAllGeneralSettings(params)),
  showToast: (params) => dispatch(showToast(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AgentSignupStyled);